import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            name: '',
            memberships: [],
            filteredMemberships: [],
            groupedPackages: [],
            hiddenGroups: [],
            dates6 : [],
            dates12 : [],
            showLoyalty: false,
            filter: ''
        }
    },
    computed : {
        orderedPayments : function () {
            return this.memberships;
        },
    },
    methods: {
        formatDate: formatDate,
        formatDate2: formatDate2,
        addMembershipPackage: addMembershipPackage,
        deleteMembership: deleteMembership,
        keymonitor: keymonitor,
        load: load,
        getPaymentClassTd: getPaymentClassTd,
        editMembership: editMembership,
        onHideGroup: onHideGroup,
         compare(a,b) {
            if (a.paidDate < b.paidDate)
                return 1;
            if (a.paidDate > b.paidDate)
                return -1;
            return 0;
        },
        groupMemberships: groupMemberships
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.load()
    },
    watch: {
        'filter': function (newVal) {
            if(newVal == null || newVal.length === 0){
                this.filteredMemberships = this.memberships;
            }else{
                this.filteredMemberships = this.memberships.filter(item =>
                    item.name.toLowerCase().indexOf(newVal.toLowerCase()) !== -1 ||
                    item.trainingTypes.toLowerCase().indexOf(newVal.toLowerCase()) !== -1 ||
                    item.category.toLowerCase().indexOf(newVal.toLowerCase()) !== -1
                )
            }
            this.groupMemberships()
        }
    }
}


function formatDate2(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY')
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {
    let _self = this;
    AdminApiService.getMemberships()
        .then((response) => {
            _self.memberships = response.data;
            _self.filteredMemberships = _self.memberships;
            _self.groupedPackages = _self.filteredMemberships.reduce((acc, item) => {
                acc[item.category] = acc[item.category] || [];
                acc[item.category].push(item);
                return acc;
            }, {});
            // _self.groupMemberships()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function groupMemberships(){
    let _self = this;
    _self.groupedPackages = _self.filteredMemberships.reduce((acc, item) => {
        acc[item.category] = acc[item.category] || [];
        acc[item.category].push(item);
        return acc;
    }, {});
    console.log(_self.groupedPackages)
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function addMembershipPackage() {
    this.$router.push('/add-membership-package')
}

function deleteMembership(id) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_membership_are_you_sure_to_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteMembership(id)
            .then((response) => {
                _self.load()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function getPaymentClassTd(payment) {
    if(payment.paidMoney <= 0){
        return "background: red;"
    }
}

function editMembership(paymentId) {
    this.$router.push('/edit-membership-package?id=' + paymentId)
}

function onHideGroup(group){
    if(this.hiddenGroups.includes(group)){
        this.hiddenGroups = this.hiddenGroups.filter(item => item !== group)
    }else{
        this.hiddenGroups.push(group)
    }
}



// WEBPACK FOOTER //
// ./src/components/Membership/MembershipPackages.js